import { createContext, Dispatch } from 'react';

import { DispatchAction } from './actions';
import { initialState, GlobalState } from './initialState';

export const globalStateContext = createContext<GlobalState>(initialState);
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const globalReducer = createContext<Dispatch<DispatchAction>>(() => {});
